import React from "react";

/**
 * 數值滑桿元件
 * 支援滑桿拖曳、數字輸入、即時顯示數值，可自訂粗細
 * @param {number} value - 當前數值
 * @param {number} min - 最小值
 * @param {number} max - 最大值
 * @param {number} step - 步進值
 * @param {function} onChange - 數值變動時回呼
 * @param {boolean} disabled - 是否禁用
 * @param {boolean} showInput - 是否顯示數字輸入框
 * @param {string} className - 外部 class
 * @param {object} style - 外部 style
 * @param {number} thickness - 滑桿粗細(px)
 */
const Slider = ({
    value = 0,
    min = 0,
    max = 100,
    step = 1,
    onChange,
    disabled = false,
    showInput = true,
    className = "",
    style = {},
    thickness = 6, // 新增：滑桿粗細
}) => {
    // 處理滑桿拖曳
    const handleSliderChange = (e) => {
        const val = Number(e.target.value);
        onChange && onChange(val);
    };
    // 處理數字輸入
    const handleInputChange = (e) => {
        let val = Number(e.target.value);
        if (isNaN(val)) val = min;
        if (val < min) val = min;
        if (val > max) val = max;
        onChange && onChange(val);
    };

    return (
        <div className={`flex items-center gap-3 ${className}`} style={style}>
            {/* 滑桿本體，使用 style 調整粗細 */}
            <input
                type="range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={handleSliderChange}
                disabled={disabled}
                className="slider"
                style={{
                    flex: 1,
                    height: thickness,
                    accentColor: "#3b82f6", // tailwind blue-500
                }}
            />
            {/* 即時顯示數值 */}
            <span className="w-12 text-center">{value}</span>
            {/* 可輸入數字 */}
            {showInput && (
                <input
                    type="number"
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    onChange={handleInputChange}
                    disabled={disabled}
                    className="border rounded px-2 py-1 w-16"
                />
            )}
        </div>
    );
};

export default Slider;
